import React from "react";
import { TextInput, maxLength, required, useTranslate } from "react-admin";
import { useForm, useFormState } from "react-final-form";

import { FormGroupGrid, GridForm, GridInput } from "../../../components/GridForm";
import { GridInputMultiChanges } from "../../../components/GridForm";
import { NumberInputEx } from "../../../components/inputs";
import { YesNoInput } from "../../../components/inputs/YesNoInput";

const ColdStorageFormGroup = ({ children, prefix, ...props }) => {
	const translate = useTranslate();

	return (
		<FormGroupGrid
			{...props}
			style={{ backgroundColor: "rgba(0, 119, 255, 0.1)" }}
			title={translate("resources.orders.block-label.cold_storage")}
		>
			{children}
		</FormGroupGrid>
	);
};

export const ColdStorageSection = (props) => {
	const { values, initialValues } = useFormState();
	const form = useForm();
	console.log(props);

	const onReeferChange = (event) => {
		const isChecked = event.target.checked;
		if (!isChecked) {
			form.change("container_number", "");
		}
	};
	const GridInputComponent = props.isMultiChanges ? GridInputMultiChanges : GridInput;

	return (
		<ColdStorageFormGroup {...props}>
			<FormGroupGrid>
				<GridInputComponent
					xs={GridInputComponent}
					md={3}
					component={YesNoInput}
					source="is_reefer"
					onChange={onReeferChange}
					validate={props.isMultiChanges ? undefined : [required()]}
				/>
				<GridInputComponent
					xs={12}
					md={3}
					component={TextInput}
					source="container_number"
					validate={[maxLength(64)]}
				/>
			</FormGroupGrid>
			<FormGroupGrid>
				<GridInputComponent xs={12} md={3} component={NumberInputEx} source="total_boxes" />
			</FormGroupGrid>
			<FormGroupGrid>
				<GridInputComponent xs={12} md={6} component={YesNoInput} source="is_photo_of_label" />
			</FormGroupGrid>
		</ColdStorageFormGroup>
	);
};
